import { getToken } from './auth';

function tryParseJson(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return jsonString;
  }
}

async function handleResponse(res) {
  const text = await res.text();
  const data = tryParseJson(text);

  if (!res.ok) {
    const error = new Error(`Request failed with status ${res.status}`);
    error.response = { status: res.status, data };
    throw error;
  }

  return data;
}

/**
 * @typedef {Object} RequestOptions
 * @property {String} path - the path of the api endpoint
 * @property {Object} [params] - optional query params to add to the url in key value pairs
 * @property {Object} [body] - optional request body to send
 * @property {String} method - the HTTP request method of the request, e.g. POST, GET, etc.
 */

/**
 *
 * @param {string} path
 * @param {RequestOptions} [options] - optional request options
 * @returns {Object} the response from the server
 */
async function apiFetch(path, options) {
  const url = new URL(path, window.config.apiUrl);

  if (options?.params) {
    Object.entries(options.params).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });
  }

  const headers = {
    Authorization: `Bearer ${getToken()}`,
  };

  const body = options?.body ? JSON.stringify(options.body) : undefined;

  if (body) {
    headers['content-type'] = 'application/json';
  }

  const response = await fetch(url.toString(), {
    method: options.method,
    body,
    headers,
  });

  return handleResponse(response);
}

/**
 *
 * @param {string} path
 * @param {object|string|number} body
 * @param {RequestOptions} [options]
 * @returns {Object} The response from the server
 */
export function post(path, body, options) {
  return apiFetch(path, {
    ...options,
    method: 'POST',
    body,
  });
}

/**
 *
 * @param {string} path
 * @param {object|string|number} body
 * @param {RequestOptions} [options]
 * @returns {Object} The response from the server
 */
export function del(path, body, options) {
  return apiFetch(path, {
    ...options,
    method: 'DELETE',
    body,
  });
}

/**
 * @param {string} path
 * @param {RequestOptions} [options]
 * @returns {Object} The response from the server
 */
export function get(path, options) {
  return apiFetch(path, {
    ...options,
    method: 'GET',
  });
}
